import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  margin-top: 32px;
`;

export const TitleBase = styled.div`
  ${typographyV2.titleBase};
  margin-bottom: 8px;
`;

export const BodySmall = styled.div`
  ${typographyV2.bodySm};
  margin-bottom: 12px;
`;
